/**
 * Grab the se (expiry) query param from a url
 * @param sasUrl
 * @returns date || null
 */
export const getExpiryFromSasUrl = (sasUrl: string): Date | null => {
    let url = new URL(sasUrl);
    let params = url.searchParams;

    const expiry: string | null = params.get("se");

    return expiry === null
        ? null
        : new Date(expiry);
}

/**
* Check if a url is valid by attempting to create an object with it.
* @param url
* @returns true if object was created without error, false if not
*/
export const checkValidUrl = (url: string): boolean => {
    try {
        new URL(url);

        var containsSpaces = url.includes(" ");
        var urlRegExpression = /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)?/gi; // eslint-disable-line
        const result = url.match(urlRegExpression);

        return result !== null && !containsSpaces;
    }
    catch {
        return false;
    }
};
